export const MILLISECONDS_IN_AN_HOUR = 60 * 60 * 1000;
export const MILLISECONDS_IN_A_MINUTE = 60 * 1000;
export const MILLISECONDS_IN_A_SECOND = 1000;
